<template>
  <label>
    <input type="checkbox" :value="item.value" :checked="isChecked" @change="handleChange" />
    <span>{{ item.label }}</span>
  </label>
</template>

<script>
export default {
  props: ["item", "isChecked", "parent"],
  methods: {
    handleChange() {
      this.$emit("passItem", this.item);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/styles/variables.less";

label {
  display: flex;
  align-items: center;
  cursor: pointer;
}

/* Hide the default checkbox */
input[type="checkbox"] {
  appearance: none; /* Removes the default styling */
  -webkit-appearance: none; /* Safari support */
  width: 16px;
  height: 16px;
  border: 1px solid #98a5bb;
  border-radius: 3px;
  cursor: pointer;
  outline: none;
}

/* Unchecked state */
input[type="checkbox"] {
  background-color: @kk-color-white;
}

/* Checked state */
input[type="checkbox"]:checked {
  border: none;
  background-color: @kk-color-primary-blue; /* Checkbox color */
}

/* Tick styling */
input[type="checkbox"]:checked::after {
  content: "";
  display: block;
  width: 16px;
  height: 16px;
  background: url("@/assets/checkmark.svg");
  background-size: cover;
}
</style>
